//# sourceMappingURL=stack.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/stack.interface.js
// module id = 1182
// module chunks = 4